import { useState, useEffect } from 'react';

export interface ProjectConfig {
    id: string;
    name: string;
    slug: string;
    token_mint: string;
    token_symbol: string;
    token_decimals: number;
    token_icon_url: string | null;
    primary_color: string;
    logo_url: string | null;
    background_url: string | null;
    is_verified: boolean;
    is_universal?: boolean;
    verification_tier?: string;
}

export function useProject() {
    const [project, setProject] = useState<ProjectConfig | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        async function fetchProject() {
            try {
                // Extract slug from hostname (e.g., "555" from "555.sw4p.io")
                const hostname = window.location.hostname;
                const parts = hostname.split('.');

                // Handle localhost development
                let slug = 'demo';
                if (hostname.includes('sw4p.io') && parts.length >= 3) {
                    slug = parts[0]; // e.g., "555", "acme"
                } else if (hostname === 'localhost' || hostname === '127.0.0.1') {
                    // Use query param for local dev: ?project=555
                    const params = new URLSearchParams(window.location.search);
                    slug = params.get('project') || '555';
                }

                const response = await fetch(`/api/v1/project/config?slug=${encodeURIComponent(slug)}`);

                if (!response.ok) {
                    if (response.status === 404) {
                        setError('Project not found');
                    } else {
                        setError('Failed to load project configuration');
                    }
                    return;
                }

                const data = await response.json();
                setProject(data);
            } catch (e) {
                console.error('Failed to fetch project:', e);
                setError('Failed to load project');
            } finally {
                setLoading(false);
            }
        }

        fetchProject();
    }, []);

    return { project, loading, error };
}
